var map = {
	"./account-balance.svg": [
		356047,
		56047
	],
	"./add-campaign-setting.svg": [
		959216,
		59216
	],
	"./add-circle.svg": [
		157157,
		57157
	],
	"./add-circleV2.svg": [
		247761,
		47761
	],
	"./add-device.svg": [
		452063,
		52063
	],
	"./add-element.svg": [
		455787,
		55787
	],
	"./add-icon.svg": [
		631450,
		31450
	],
	"./add-room.svg": [
		847112,
		47112
	],
	"./add-schedule.svg": [
		630186,
		30186
	],
	"./add-square-2.svg": [
		796597,
		96597
	],
	"./add-square.svg": [
		692920,
		92920
	],
	"./add.svg": [
		286264,
		86264
	],
	"./after-payments.svg": [
		56413,
		56413
	],
	"./alarm.svg": [
		722026,
		22026
	],
	"./alert-error.svg": [
		40090,
		40090
	],
	"./alert-success.svg": [
		922825,
		22825
	],
	"./alert-warning.svg": [
		547748,
		47748
	],
	"./apply-filter.svg": [
		254328,
		54328
	],
	"./arrow-down.svg": [
		236687,
		36687
	],
	"./arrow-icon.svg": [
		249136,
		49136
	],
	"./arrow-left.svg": [
		343856,
		43856
	],
	"./arrow-right.svg": [
		303647,
		3647
	],
	"./arrow-up-right.svg": [
		466609,
		66609
	],
	"./attach.svg": [
		649664,
		49664
	],
	"./bag-cash.svg": [
		273497,
		73497
	],
	"./bank.svg": [
		385081,
		85081
	],
	"./bar-report.svg": [
		216485,
		16485
	],
	"./bar.svg": [
		60362,
		60362
	],
	"./base-icon.svg": [
		757902,
		57902
	],
	"./beer-count-one.svg": [
		532472,
		32472
	],
	"./beer.svg": [
		148513,
		48513
	],
	"./blocked.svg": [
		816869,
		16869
	],
	"./brazil.svg": [
		63481,
		63481
	],
	"./buyer-recharge.svg": [
		520958,
		20958
	],
	"./calendar-date.svg": [
		475826,
		75826
	],
	"./calendar-time.svg": [
		717681,
		17681
	],
	"./calendar_date.svg": [
		314360,
		14360
	],
	"./camera.svg": [
		136934,
		36934
	],
	"./cart.svg": [
		525969,
		25969
	],
	"./cash-bag.svg": [
		752175,
		52175
	],
	"./cash-flow.svg": [
		731267,
		31267
	],
	"./cash-withdrawal.svg": [
		11250,
		11250
	],
	"./cash.svg": [
		91034,
		91034
	],
	"./chair-table.svg": [
		796465,
		96465
	],
	"./chair.svg": [
		402698,
		2698
	],
	"./chat-solid.svg": [
		620915,
		20915
	],
	"./chat.svg": [
		199501,
		99501
	],
	"./check-2.svg": [
		917608,
		17608
	],
	"./check-circle.svg": [
		252574,
		52574
	],
	"./check-icon.svg": [
		521109,
		21109
	],
	"./check-payment-give.svg": [
		762018,
		62018
	],
	"./check-small.svg": [
		678643,
		78643
	],
	"./check.svg": [
		188641,
		88641
	],
	"./chevron-arrow.svg": [
		447200,
		24819
	],
	"./chevron-back.svg": [
		570116,
		70116
	],
	"./chevron-double-left.svg": [
		757708,
		57708
	],
	"./chevron-double-right.svg": [
		839155,
		39155
	],
	"./chevron-down.svg": [
		512629,
		12629
	],
	"./chevron-down2.svg": [
		57917,
		57917
	],
	"./chevron-right.svg": [
		158125,
		58125
	],
	"./chevron-up-down.svg": [
		436243,
		36243
	],
	"./chevron-up.svg": [
		63130,
		63130
	],
	"./clean.svg": [
		398470,
		98470
	],
	"./clear.svg": [
		345106,
		45106
	],
	"./cloche.svg": [
		545237,
		45237
	],
	"./clock-campaign.svg": [
		548322,
		48322
	],
	"./clock.svg": [
		310731,
		10731
	],
	"./close-full-screen.svg": [
		423238,
		23238
	],
	"./close.svg": [
		347549,
		47549
	],
	"./closeV2.svg": [
		482217,
		82217
	],
	"./color-circle.svg": [
		123089,
		23089
	],
	"./convertion.svg": [
		39678,
		39678
	],
	"./copy.svg": [
		714248,
		14248
	],
	"./copy2.svg": [
		553962,
		53962
	],
	"./costumer.svg": [
		314215,
		14215
	],
	"./costumers.svg": [
		155222,
		55222
	],
	"./couvert.svg": [
		807231,
		7231
	],
	"./create-product-success.svg": [
		109103,
		9103
	],
	"./data-export-dark.svg": [
		256679,
		56679
	],
	"./data-export.svg": [
		173502,
		73502
	],
	"./day.svg": [
		725075,
		25075
	],
	"./delete.svg": [
		61682,
		61682
	],
	"./delivery-person.svg": [
		470547,
		70547
	],
	"./delivery.svg": [
		576035,
		76035
	],
	"./desk-resource.svg": [
		34389,
		34389
	],
	"./disconnect.svg": [
		78213,
		78213
	],
	"./dollar-money.svg": [
		456102,
		56102
	],
	"./download-2.svg": [
		355698,
		55698
	],
	"./download.svg": [
		321927
	],
	"./drag.svg": [
		580269,
		80269
	],
	"./drop-percentage.svg": [
		524437,
		24437
	],
	"./edit-square.svg": [
		174677,
		74677
	],
	"./edit.svg": [
		163151,
		63151
	],
	"./email-icon.svg": [
		173253,
		73253
	],
	"./email.svg": [
		361329,
		61329
	],
	"./empty-search.svg": [
		284739,
		84739
	],
	"./empty-state-giftback.svg": [
		803308,
		3308
	],
	"./empty-state.svg": [
		716114,
		16114
	],
	"./error.svg": [
		292031,
		92031
	],
	"./exchange.svg": [
		886572,
		86572
	],
	"./external.svg": [
		217930,
		17930
	],
	"./female.svg": [
		743703,
		43703
	],
	"./file-check.svg": [
		687306,
		87306
	],
	"./file-excel.svg": [
		539035,
		39035
	],
	"./file-pdf.svg": [
		435172,
		35172
	],
	"./files-multiple.svg": [
		843357,
		43357
	],
	"./filter.svg": [
		597137,
		97137
	],
	"./financial-report.svg": [
		298115,
		98115
	],
	"./fiscal-printer.svg": [
		164854,
		64854
	],
	"./fiscal.svg": [
		73181,
		73181
	],
	"./french.svg": [
		95203,
		95203
	],
	"./full-screen.svg": [
		19569,
		19569
	],
	"./future-wallet.svg": [
		667148,
		67148
	],
	"./gift-card.svg": [
		788416,
		88416
	],
	"./graph.svg": [
		452193,
		52193
	],
	"./help.svg": [
		600578,
		578
	],
	"./hide.svg": [
		960243,
		60243
	],
	"./history.svg": [
		574561,
		74561
	],
	"./home-circle.svg": [
		899131,
		99131
	],
	"./home.svg": [
		971550,
		71550
	],
	"./hop-flower.svg": [
		799820,
		99820
	],
	"./image-outline.svg": [
		910059,
		10059
	],
	"./image-placeholder.svg": [
		232362,
		32362
	],
	"./image-stock.svg": [
		414915,
		14915
	],
	"./inconsistencies.svg": [
		258674,
		58674
	],
	"./info-all-black.svg": [
		178595,
		78595
	],
	"./info-outlined.svg": [
		333206,
		33206
	],
	"./info.svg": [
		732339
	],
	"./kitchen.svg": [
		174873,
		74873
	],
	"./lightbulb.svg": [
		146144,
		46144
	],
	"./link-product-to-bar.svg": [
		480409,
		80409
	],
	"./link.svg": [
		853359,
		53359
	],
	"./list.svg": [
		755687,
		55687
	],
	"./location-circle.svg": [
		378003,
		78003
	],
	"./mail.svg": [
		696550,
		96550
	],
	"./male.svg": [
		714116,
		14116
	],
	"./medal.svg": [
		689424,
		89424
	],
	"./megaphone.svg": [
		505535,
		5535
	],
	"./mesa.svg": [
		300273,
		273
	],
	"./mexico.svg": [
		649142,
		49142
	],
	"./minus.svg": [
		434201,
		34201
	],
	"./money-atm.svg": [
		884258,
		84258
	],
	"./money-bag.svg": [
		539844,
		39844
	],
	"./money-bags.svg": [
		573199,
		73199
	],
	"./money-box.svg": [
		767861,
		67861
	],
	"./money-bubble.svg": [
		932284,
		32284
	],
	"./money-circle.svg": [
		324238,
		24238
	],
	"./money-exchange.svg": [
		441097,
		41097
	],
	"./money-sign.svg": [
		927637,
		27637
	],
	"./money-withdraw-in.svg": [
		236268,
		36268
	],
	"./money-withdraw-out.svg": [
		998707,
		98707
	],
	"./money.svg": [
		772689,
		72689
	],
	"./more-vertical.svg": [
		621111,
		21111
	],
	"./multivendor.svg": [
		685524,
		85524
	],
	"./music.svg": [
		415848,
		15848
	],
	"./navigate-page.svg": [
		249298,
		49298
	],
	"./options.svg": [
		662771,
		62771
	],
	"./order-alphabetic.svg": [
		367243,
		67243
	],
	"./order-clock.svg": [
		122548,
		22548
	],
	"./order.svg": [
		894033,
		94033
	],
	"./other-gender.svg": [
		5571,
		5571
	],
	"./paper-plane.svg": [
		278774,
		78774
	],
	"./pdv-money.svg": [
		642424,
		42424
	],
	"./pdv-zig.svg": [
		576158,
		76158
	],
	"./pencil-circle.svg": [
		667317,
		67317
	],
	"./percentage-bold.svg": [
		597037,
		97037
	],
	"./percentage.svg": [
		787083,
		87083
	],
	"./person.svg": [
		565972,
		65972
	],
	"./phone.svg": [
		713689,
		13689
	],
	"./price.svg": [
		730082,
		30082
	],
	"./printer.svg": [
		503609,
		3609
	],
	"./product-add.svg": [
		391342,
		91342
	],
	"./product-cancel.svg": [
		842011,
		42011
	],
	"./product-check.svg": [
		694979,
		94979
	],
	"./product-details.svg": [
		147293,
		47293
	],
	"./product-empty-state.svg": [
		735836,
		35836
	],
	"./product-return.svg": [
		931119,
		31119
	],
	"./product-sells.svg": [
		678136,
		78136
	],
	"./product.svg": [
		980400,
		80400
	],
	"./production-rule.svg": [
		393573,
		93573
	],
	"./products.svg": [
		824755,
		24755
	],
	"./promotions.svg": [
		83125,
		83125
	],
	"./qr-code.svg": [
		792056,
		92056
	],
	"./qrcode-circle.svg": [
		533161,
		55542
	],
	"./rasps.svg": [
		809888,
		9888
	],
	"./recharge-info.svg": [
		299905,
		99905
	],
	"./refresh.svg": [
		330288,
		30288
	],
	"./refreshV2.svg": [
		372384,
		72384
	],
	"./refund-reason.svg": [
		645322,
		45322
	],
	"./refund.svg": [
		480145,
		80145
	],
	"./relations.svg": [
		861598,
		61598
	],
	"./release-money.svg": [
		500965,
		965
	],
	"./remove-circle.svg": [
		882536,
		82536
	],
	"./remove-clear.svg": [
		66883,
		66883
	],
	"./remove-square.svg": [
		402161,
		2161
	],
	"./reset-positions.svg": [
		533923,
		33923
	],
	"./resize.svg": [
		363447,
		63447
	],
	"./return-money.svg": [
		360614,
		60614
	],
	"./ri-arrow-up-line.svg": [
		715425,
		15425
	],
	"./ri-bank-card-2-line.svg": [
		487402,
		87402
	],
	"./ri-bar-chart-box-line.svg": [
		844414,
		44414
	],
	"./ri-calendar-line.svg": [
		156446,
		56446
	],
	"./ri-drinks-2-line.svg": [
		473060,
		73060
	],
	"./ri-football-line.svg": [
		771325,
		71325
	],
	"./ri-group-line.svg": [
		94129,
		94129
	],
	"./ri-hourglass-line.svg": [
		108604,
		8604
	],
	"./ri-money-dollar-circle-line.svg": [
		849126,
		49126
	],
	"./ri-plane-line.svg": [
		853484,
		53484
	],
	"./ri-refresh-line.svg": [
		975045,
		75045
	],
	"./ri-rocket-2-line.svg": [
		202091,
		2091
	],
	"./ri-time-line.svg": [
		449769,
		49769
	],
	"./ri-trophy-line.svg": [
		280818,
		80818
	],
	"./ri-user-add-line.svg": [
		412945,
		12945
	],
	"./ri-wallet-3-line.svg": [
		647893,
		47893
	],
	"./sale-slip-disabled.svg": [
		618422,
		18422
	],
	"./sale-slip.svg": [
		24537,
		24537
	],
	"./sales.svg": [
		74985,
		74985
	],
	"./search-dark.svg": [
		811500,
		11500
	],
	"./search.svg": [
		823415,
		23415
	],
	"./select-arrow-right.svg": [
		694062,
		94062
	],
	"./selector-arrow-right.svg": [
		797613,
		97613
	],
	"./send-icon.svg": [
		860293,
		60293
	],
	"./send.svg": [
		731953,
		31953
	],
	"./service-report.svg": [
		292339,
		92339
	],
	"./settings.svg": [
		841932,
		41932
	],
	"./settingsV2.svg": [
		473140,
		73140
	],
	"./shield-security.svg": [
		228023,
		28023
	],
	"./shine.svg": [
		562752,
		62752
	],
	"./shipment-upload.svg": [
		697321,
		97321
	],
	"./short-arrow-down.svg": [
		346956,
		46956
	],
	"./smartphone.svg": [
		98546,
		98546
	],
	"./spain.svg": [
		899846,
		99846
	],
	"./star.svg": [
		495663,
		95663
	],
	"./stock-report.svg": [
		533082,
		33082
	],
	"./stock.svg": [
		234147,
		34147
	],
	"./store.svg": [
		212598,
		12598
	],
	"./success.svg": [
		702084,
		2084
	],
	"./sun.svg": [
		351567,
		51567
	],
	"./sync-warning.svg": [
		660889,
		60889
	],
	"./synchronize.svg": [
		315611,
		15611
	],
	"./t-money.svg": [
		935682,
		35682
	],
	"./table-chair.svg": [
		856569,
		56569
	],
	"./table-money-sig.svg": [
		158942,
		58942
	],
	"./table-money.svg": [
		589862,
		89862
	],
	"./table.svg": [
		962361,
		62361
	],
	"./tag-alert.svg": [
		186620,
		86620
	],
	"./task-list-edit.svg": [
		432950,
		32950
	],
	"./test-fiscal.svg": [
		860202,
		60202
	],
	"./three-dots-icon.svg": [
		525664,
		25664
	],
	"./tickets.svg": [
		35850,
		35850
	],
	"./timezone.svg": [
		727786,
		27786
	],
	"./totem.svg": [
		993982,
		93982
	],
	"./transfer.svg": [
		244782,
		44782
	],
	"./trash.svg": [
		778427,
		78427
	],
	"./trashV2.svg": [
		36095,
		36095
	],
	"./travel-map.svg": [
		335594,
		35594
	],
	"./truck.svg": [
		439500,
		39500
	],
	"./unlock.svg": [
		20411,
		20411
	],
	"./upload.svg": [
		77128,
		77128
	],
	"./uploaded-file.svg": [
		314678,
		14678
	],
	"./usa.svg": [
		471924,
		71924
	],
	"./user-delete.svg": [
		398586,
		98586
	],
	"./user-money.svg": [
		653849,
		53849
	],
	"./user.svg": [
		420714,
		20714
	],
	"./users-dark.svg": [
		788126,
		88126
	],
	"./users.svg": [
		298421,
		98421
	],
	"./utensil.svg": [
		219143,
		19143
	],
	"./view-details.svg": [
		296305,
		96305
	],
	"./view.svg": [
		268060,
		68060
	],
	"./wallet.svg": [
		267456,
		67456
	],
	"./warning-icon.svg": [
		846693,
		46693
	],
	"./warning-triangle.svg": [
		137934,
		37934
	],
	"./warning-triangular.svg": [
		388125,
		88125
	],
	"./warning.svg": [
		746001,
		46001
	],
	"./whatsapp.svg": [
		675601,
		75601
	],
	"./withdraw.svg": [
		487777,
		87777
	],
	"./ze-delivery-tag.svg": [
		106070,
		6070
	],
	"./ze-delivery.svg": [
		977945,
		77945
	],
	"./zig-cash.svg": [
		395177,
		95177
	],
	"./zig-person.svg": [
		730207,
		30207
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629532;
module.exports = webpackAsyncContext;